/**
 * Path stored in tag `hasPermissionPages` (no `/:param` segments).
 * Must stay aligned with `UserPermission` permission checks.
 */
export function toTagPermissionStoragePath(page: string): string {
  const cleaned = page.replace(/\/:[^/]+/g, '');
  const normalized = cleaned === '/' ? cleaned : cleaned.replace(/\/+$/, '');
  return normalized.startsWith('/') ? normalized : `/${normalized}`;
}
